<br>
<div class="col-md-8 col-sm-10 col-xs-12 border" style="margin-left:20px;">
  <form [formGroup]="institutionform">
    <div *ngIf="(isClerk || isSysAdmin || isFinancialOfficerCamp)" class="form-group">
      <label for="institutionId" *ngIf="displayInstitutionChooser">Välj institution</label>
      <p-select id="institutionId" [options]="institutionslist" [multiple]="false" [checkbox]="false" [showClear]="true" [filter]="true" formControlName="institutionId" optionLabel="name" [listStyle]="{'max-height':'200px'}" [style]="{'width':'300px'}" appendTo="body"
        (onChange)="setInstitution($event)"></p-select>
    </div>
    <div *ngIf="((!isClerk && !isSysAdmin) && !isFinancialOfficerCamp)" class="form-group">
      <label for="institutionId">Välj institution</label>
      <select class="form-control form-control-sm" id="institutionId" formControlName="institutionId" style="width: 300px;" (change)="setInstitution($event)" required>
        <option></option>
        <option *ngFor="let i of institutionlist" [value]="i.id">{{i.shortName}} {{i.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <div *ngIf="institutionform.valid">
        <div class="form-group">
          <label for="actioncontrol">Välj åtgärd</label>
          <select class="form-control form-control-sm" id="actioncontrol" style="width:300px;" (change)="setAction($event)">
            <option></option>
            <option value="searchMeeting">Sök möte för {{institution.name}}</option>
            <option value="viewInstitution">Se institutionsinformation</option>
            <option *ngIf="isAdmin" value="addMeeting">Lägg till möte</option>
          </select>
        </div>
      </div>
    </div>
  </form>
  <br>
  <div *ngIf="link==='searchMeeting'" class="row">
    <div class="col-md-12">
      <app-searchmeeting [institution]=institution memberid=memberid (closeSearchMeeting)="closeSearchMeeting($event)"></app-searchmeeting>
    </div>
  </div>
  <div *ngIf="link==='addMeeting'" class="row">
    <div class="col-md-12">
      <app-addmeeting [institution]=institution (closeAddMeeting)="closeAddMeeting($event)"></app-addmeeting>
    </div>
  </div>
  <div *ngIf="link==='registerPaymentsMulti'" class="row">
    <div class="col-md-12">
      <app-registerpaymentsmulti [institution]=institution [year]=selectedyear></app-registerpaymentsmulti>
    </div>
  </div>
  <div *ngIf="link==='nedsattning'" class="row">
    <div class="col-md-12">
      <app-nedsattning [institution]=institution [year]=selectedyear></app-nedsattning>
    </div>
  </div>
</div>